module.exports = __webpack_public_path__ + "static/mabry-light-pro-5f1d7f99138bf637694689201f4c5426.woff2";